import React from "react";
import { connect } from "react-redux";

import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import mileageTrackerIcon from "assets/reports/mileageTrackerUpsell.svg";
import { defineMessages, useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import { MILEAGE_TRACKING_UPSELL_URL } from "@app/scene/map/utils/consts";
import { isCurrentUserOwner } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";

import { mileageTrackerTitle } from "..";

import styles from "./MileageTrackingUpsell.module.scss";

const messages = defineMessages({
  automaticTracking: {
    id: "reports.mileageTracking.upsell.automaticTracking",
    defaultMessage: "Track drives automatically",
    description: "Automatic tracking info",
  },
  autoOrManual: {
    id: "reports.mileageTracking.upsell.autoOrManual",
    defaultMessage: "Determine whether a drive was auto-tracked or manually logged",
    description: "Auto track or manual",
  },
  classification: {
    id: "reports.mileageTracking.upsell.classification",
    defaultMessage: "Drives classified based on working hours",
    description: "Drives classification info",
  },
  export: {
    id: "reports.mileageTracking.upsell.export",
    defaultMessage: "Export comprehensive reports in seconds",
    description: "Export reports",
  },
  interested: {
    id: "reports.mileageTracking.upsell.interested",
    defaultMessage: "I’m Interested",
    description: "Interested button",
  },
  liveReports: {
    id: "reports.mileageTracking.upsell.liveReports",
    defaultMessage: "Access live reports on all drives",
    description: "Live reports info",
  },
  monitor: {
    id: "reports.mileageTracking.upsell.monitor",
    defaultMessage: "Monitor business drives in real time",
    description: "Monitor business",
  },
  shareReport: {
    id: "reports.mileageTracking.upsell.shareReport",
    defaultMessage: "Share a detailed report instantly",
    description: "Share drive reports info",
  },
  teamDriveTime: {
    id: "reports.mileageTracking.upsell.teamDriveTime",
    defaultMessage: "Track your team's driving time effortlessly",
    description: "Track team's drive time",
  },
  title: {
    id: "reports.mileageTracking.upsell.title",
    defaultMessage: "Auto-track and classify drives",
    description: "Upsell title",
  },
});

const upsellBulletPoints = [
  messages.automaticTracking,
  messages.classification,
  messages.liveReports,
  messages.shareReport,
];

const ownerBullerPoints = [
  messages.teamDriveTime,
  messages.autoOrManual,
  messages.monitor,
  messages.export,
];

interface Props {
  isOwner: boolean;
}

const MileageTrackingUpsell: React.FC<Props> = ({ isOwner }) => {
  const intl = useIntl();
  return (
    <div>
      <div className={styles.title}>{intl.formatMessage(mileageTrackerTitle)}</div>
      <div className={styles.container}>
        <img alt="mileage tracker icon" className={styles.icon} src={mileageTrackerIcon} />
        <span className={styles.subTitle}>{intl.formatMessage(messages.title)}</span>
        <div className={styles.bullets}>
          {(isOwner ? ownerBullerPoints : upsellBulletPoints).map((message) => (
            <div className={styles.point} key={message.id}>
              <FontAwesomeIcon className={styles.primary} icon={faCircleCheck} size="lg" />
              <span>{intl.formatMessage(message)}</span>
            </div>
          ))}
        </div>
        <Button href={MILEAGE_TRACKING_UPSELL_URL} target="_blank" type="primary">
          {intl.formatMessage(messages.interested)}
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({ isOwner: isCurrentUserOwner(state) });

export default connect(mapStateToProps)(MileageTrackingUpsell);
